<template>
    <div>
        <div class="flex items-center justify-between">
            <breadcrumbs>Werkgevergebruikers</breadcrumbs>
            <!-- <link-button :href="route('admin.company-users.create')" icon="plus" class="bg-white">Nieuwe user</link-button> -->
        </div>

        <h1 class="text-5xl text-teal-800">Werkgevergebruikers</h1>

        <div class="flex justify-between items-center mb-5">
            <div class="flex flex-col">
                <search-filter v-model="form.search" class="w-full max-w-sm mr-4" @reset="reset" @input="submitSearch">
                    <label class="block">Bedrijf:</label>
                    <select v-model="form.filter_company" class="mt-1 w-full form-select" @change="reloadData">
                        <option :value="null" />
                        <option v-for="(company, id) in companies" :key="id" :value="id">{{ company }}</option>
                    </select>
                </search-filter>

                <active-filters :filters="filters" @remove-filter="removeFilter" />
            </div>

            <num-results name="users"
                         :from="users.from"
                         :to="users.to"
                         :total="users.total"
            />

            <input type="hidden" v-model="form.orderBy" />
            <input type="hidden" v-model="form.sortOrder" />
        </div>

        <p v-if="!users.data.length">Er zijn geen gebruikers gevonden.</p>

        <table v-if="users.data.length" class="w-full whitespace-no-wrap bg-white rounded">
            <thead>
                <tr class="text-teal-800 font-bold">

                    <td class="px-3 py-3 text-left whitespace-nowrap">
                        <a href @click.prevent="sort('id')" class="hover:underline">ID<sort-icon col="id" :orderby="filters.orderBy" :sortorder="filters.sortOrder" /> </a>
                    </td>
                    <td class="px-3 py-3 whitespace-nowrap">
                        <a href @click.prevent="sort('created_at')" class="hover:underline">
                            <i class="fal fa-calendar-plus mr-1"></i>Created<sort-icon col="created_at" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </td>

                    <td class="px-3 py-3 whitespace-nowrap">
                        <a href @click.prevent="sort('company_id')" class="hover:underline">
                            <i class="fal fa-building mr-1"></i>Bedrijf<sort-icon col="company_id" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </td>

                    <td class="px-3 py-3 text-center whitespace-nowrap">
                        Image
                    </td>

                    <td class="px-3 py-3 whitespace-nowrap">
                        <a href @click.prevent="sort('first_name')" class="hover:underline">
                            First name<sort-icon col="first_name" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </td>

                    <td class="px-3 py-3 whitespace-nowrap">
                        <a href @click.prevent="sort('last_name')" class="hover:underline">
                            Last name<sort-icon col="last_name" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </td>

                    <td class="px-3 py-3 whitespace-nowrap">
                        <a href @click.prevent="sort('email')" class="hover:underline">
                            E-mail<sort-icon col="email" :orderby="filters.orderBy" :sortorder="filters.sortOrder" />
                        </a>
                    </td>

                    <!-- <td class="px-3 py-3">
                        Tel
                    </td> -->

                    <td width="200"></td>
                </tr>
            </thead>

            <tr
                v-for="(user, index) in users.data"
                :key="users.id"
                class="hover:text-teal-900 hover:bg-teal-300 focus-within:bg-teal-300 :text-teal-900"
                :class="{ 'bg-teal-100': !(index % 2), 'text-gray-500': user.deleted_at }"
            >
                <!-- <td class="border-t" width="10">
                    <span v-if="user.deleted_at" class="text-gray-500 mx-5"><i class="fad fa-trash mr-1"></i></span>
                </td> -->

                <td class="px-3 border-t">
                    <inertia-link class="py-4 flex items-center focus:font-bold" :href="route('admin.company-users.show', user.id)" tabindex="-1">
                        {{ user.id }}
                    </inertia-link>
                </td>

                <td class="px-3 border-t">
                    <inertia-link class="py-4 flex items-center" :href="route('admin.company-users.show', user.id)" tabindex="-1">
                        <div v-if="user.created_at">
                            {{ moment(user.created_at).format("DD-MM-YYYY") }}
                        </div>
                    </inertia-link>
                </td>

                <td class="px-3 border-t">
                    <inertia-link class="py-4 flex items-center focus:font-bold" :href="route('admin.company-users.show', user.id)" tabindex="-1">
                        {{ user.company.name }}
                    </inertia-link>
                </td>

                <td class="px-3 border-t">
                    <inertia-link class="flex items-center focus:text-teal-800 truncate justify-center" :href="route('admin.company-users.show', user.id)">
                        <img v-if="user.avatar" :src="user.avatar" alt="" class="h-10 rounded-full" />
                    </inertia-link>
                </td>

                <td class="px-3 border-t">
                    <inertia-link class="py-4 flex items-center focus:text-teal-800 truncate" :href="route('admin.company-users.show', user.id)">
                        {{ user.first_name }}
                    </inertia-link>
                </td>

                <td class="px-3 border-t">
                    <inertia-link class="py-4 flex items-center focus:text-teal-800 truncate" :href="route('admin.company-users.show', user.id)">
                        {{ user.last_name }}
                    </inertia-link>
                </td>

                <td class="px-3 border-t">
                    <inertia-link class="py-4 flex items-center focus:text-teal-800 truncate" :href="route('admin.company-users.show', user.id)">
                        {{ user.email }}
                    </inertia-link>
                </td>

                <!-- <td class="px-3 border-t">
                    <inertia-link class="py-4 flex items-center focus:text-teal-800 truncate" :href="route('admin.users.show', user.id)">
                        {{ user.phone }}
                    </inertia-link>
                </td> -->

                <td class="text-right pr-5 border-t">
                    <div v-if="!user.deleted_at">
                        <link-button :href="route('admin.company-users.edit', user.id)" icon="pencil" class="hover:bg-white"></link-button>
                        <confirm-button method="delete" :href="route('admin.company-users.destroy', user.id)" icon="trash" class="bg-white hover:bg-red-600 hover:text-white"></confirm-button>
                    </div>
                </td>
            </tr>
        </table>

        <pagination :links="users.links" />
    </div>
</template>

<script>
import _ from "lodash";
import Layout from "@/admin/Shared/Layout";
import SortIcon from "@/admin/Shared/SortIcon";
import Pagination from "@/admin/Shared/Pagination";
import SearchFilter from "@/admin/Shared/SearchFilter";
import ActiveFilters from "@/admin/Shared/ActiveFilters";
import NumResults from "@/admin/Shared/NumResults";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import LinkButton from "@/admin/Shared/LinkButton";
import SimpleButton from "@/admin/Shared/SimpleButton";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import ConfirmButton from "@/admin/Shared/ConfirmButton";


export default {
    metaInfo: { title: "Gebruikers" },

    layout: Layout,

    remember: "form",

    mixins: [Helpers],

    components: {
        Pagination,
        SearchFilter,
        ActiveFilters,
        SortIcon,
        NumResults,
        Breadcrumbs,
        LinkButton,
        SimpleButton,
        ConfirmButton
    },

    props: {
        users: Object,
        filters: Object,
        companies: Object,
    },
    data() {
        return {
            form: {
                trashed: this.filters.trashed,
                active: this.filters.active,
                search: this.filters.search,
                orderBy: this.filters.orderBy,
                sortOrder: this.filters.sortOrder
            }
        };
    },
    methods: {
        deleteUsers(user) {
            this.$inertia.delete(this.route("admin.company-users.destroy", user.id), {
                preserveScroll: true
            });
        },

        reloadData() {
            let queryParams = _.pickBy(this.form);
            this.$inertia.replace(this.route("admin.company-users.index", Object.keys(queryParams).length ? queryParams : { remember: "forget" }));
        },

        sort(col) {
            this.form.sortOrder = this.getNewSortOrder(col, this.form.orderBy, this.form.sortOrder);
            this.form.orderBy = col;
            this.reloadData();
        },

        submitSearch: _.debounce(function() {
            this.reloadData();
        }, 250),

        reset() {
            this.form = _.mapValues(this.form, () => null);
            this.reloadData();
        },

        removeFilter(filterName) {
            this.form[filterName] = null;
            this.reloadData();
        }
    }
};
</script>
